import(/* webpackMode: "eager" */ "/opt/build/repo/app/(search)/grant-database/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/.pnpm/@apollo+client-react-streaming@0.12.3_@apollo+client@3.14.0_@types+react@19.2.7_graphql_c0c766c31ff4aebbf1d458a7a578c58f/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Role"] */ "/opt/build/repo/node_modules/.pnpm/@ariakit+react@0.4.17_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/@ariakit/react/esm/index.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/column/column.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/context.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/list/list.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/list/list.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/markdown/markdown.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/search/result/grant/grantSearchResult.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientSearch"] */ "/opt/build/repo/src/ui/components/search/search.client.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/search/search.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/textBlock/textBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/styles/spacing.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/v1/components/list/item/grant/grant.module.scss");
